import { Primary } from "./Button.styles";

export const PrimaryButton = Primary;
